import styled from 'styled-components';
import { Button } from '~/components/button';
import { Container } from '~/components/layout';
import { Description } from '../typography';

export const DropzoneContainer = styled(Container)<{ isDragActive: boolean }>`
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  background-color: #f1f3ef;
  cursor: pointer;
  border-color: #ccc;
  margin: 16px 0;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #007bff;
  }

  ${props =>
    props.isDragActive &&
    `
    border-color: #007bff;
  `}
`;

export const UploadButton = styled(Button)`
  background-color: #4ade80;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 150px !important;
  margin: 0 auto;
  font-size: 14px;
  &:hover {
    background-color: #22c55e;
  }
  &:active {
    background-color: #16a34a;
  }
  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`;
export const UploadButtonIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropzoneDescription = styled(Description)`
  font-size: 14px;
  padding: 0 0 16px;
  margin-bottom: 0;
  text-align: center;
  color: #0d2727;
`;

export const FormatDescription = styled(Description)`
  font-size: 14px;
  padding: 16px 0;
  text-align: center;
  margin-bottom: 0;
  color: #0d2727;
`;

export const UploadButtonCopy = styled.span`
  font-size: 12px;
  word-wrap: break-word;
  width: 200px;
  display: inline-block;
  text-align: center;
  padding-top: 10px;
`;

export const UploadButtonCopyIRA = styled.span`
  word-wrap: break-word;
  display: inline-block;
  text-align: center;
`;
